<template>
  <div id="app">
    <a-config-provider :locale="locale">
      <vue-scroll ref="scrollbar" :ops="scrollOptions" :style="{height: windowHeight + 'px'}">
        <router-view v-if="isRouterAlive" />
      </vue-scroll>
    </a-config-provider>
  </div>
</template>

<script>
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN'
import en_US from 'ant-design-vue/lib/locale-provider/en_US'
export default {
  name: 'App',
  data() {
    return {
      windowHeight: (document.documentElement.clientHeight || document.body.clientHeight) - 1,
      isRouterAlive: true,
      scrollOptions: {
        bar: {
          showDelay: 0,
          /** 是否只在滚动的时候现实滚动条 */
          onlyShowBarOnScroll: true,
          /** 是否保持显示 */
          keepShow: false,
          background: '#c1c1c1',
          opacity: 1,
          size: '0px'
        }
      }
    }
  },
  computed: {
    locale() {
      return this.$store.state.app.language === 'en' ? en_US : zh_CN
    }
  },
  watch: {
    $route() {
      this.$refs.scrollbar.scrollTo(0, 0)
    }
  },
  provide() {
    return {
      reload: this.reload
    }
  },
  mounted() {
    window.addEventListener('resize', this.windowChange)
    function checkIE() {
      return '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style
    }
    if (checkIE()) {
      window.addEventListener('hashchange', () => {
        var currentPath = window.location.hash.slice(1)
        if (this.$route.path !== currentPath) {
          this.$router.push(currentPath)
        }
      }, false)
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.windowChange)
  },
  methods: {
    windowChange: function() {
      this.windowHeight = document.documentElement.clientHeight || document.body.clientHeight
    },
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function() {
        this.isRouterAlive = true
      })
    }
  }
}
</script>

<style lang="less">
@import '~@/assets/style/less/base';
@import '~@/assets/style/less/public';
.__view{width: auto!important; min-height: auto!important;}
</style>



// WEBPACK FOOTER //
// src/App.vue